import script from "./StaffFormPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaffFormPage.vue?vue&type=script&setup=true&lang=ts"

import "./StaffFormPage.vue?vue&type=style&index=0&id=3395ec6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3395ec6d"]])

export default __exports__